import { Error } from '../../../../../../../ErrorHandling';
import { MulticheckStore } from '../../../../../../../Multicheck/Store';
import { Resource } from '../../../../../../../Resource/Types';
import { InvitationResource } from '../../../Store/Types';

export type InvitationStatus = 'inactive' | 'active';

export interface Waiting {
  kind: 'waiting';
}

interface BaseState {
  multicheckStore: MulticheckStore<InvitationResource>;
  invitationStatus: InvitationStatus;
}

interface SuccessState {
  resource: BulkInvitationsResource;
  invitationStatus: InvitationStatus;
}

export interface ConfirmingDeactivate extends BaseState {
  kind: 'confirming-deactivate';
}

export interface Deactivating extends BaseState {
  kind: 'deactivating';
}

export interface Reactivating extends BaseState {
  kind: 'reactivating';
}

export interface DeactivateSucceeded extends SuccessState {
  kind: 'deactivate-succeeded';
}

export interface ReactivateSucceeded extends SuccessState {
  kind: 'reactivate-succeeded';
}

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const confirmingDeactivate = (
  multicheckStore: MulticheckStore<InvitationResource>,
): ConfirmingDeactivate => ({
  kind: 'confirming-deactivate',
  multicheckStore,
  invitationStatus: 'inactive',
});

export const deactivating = (state: ConfirmingDeactivate): Deactivating => {
  const { kind, ...previous } = state;
  return {
    kind: 'deactivating',
    ...previous,
  };
};

export const reactivating = (
  multicheckStore: MulticheckStore<InvitationResource>,
): Reactivating => ({
  kind: 'reactivating',
  multicheckStore,
  invitationStatus: 'active',
});

export const deactivateSucceeded = (
  resource: BulkInvitationsResource,
  state: Deactivating,
): DeactivateSucceeded => {
  const { kind, ...previous } = state;
  return {
    kind: 'deactivate-succeeded',
    ...previous,
    resource,
  };
};

export const reactivateSucceeded = (
  resource: BulkInvitationsResource,
  state: Reactivating,
): ReactivateSucceeded => {
  const { kind, ...previous } = state;
  return {
    kind: 'reactivate-succeeded',
    ...previous,
    resource,
  };
};

export type State =
  | Waiting
  | ConfirmingDeactivate
  | Deactivating
  | Reactivating
  | DeactivateSucceeded
  | ReactivateSucceeded
  | Error;

export interface BulkInvitations {
  attemptedCount: number;
  successCount: number;
  invitationStatus: InvitationStatus;
  updatedInvitations: InvitationResource[];
}

export type BulkInvitationsResource = Resource<BulkInvitations>;
